import "../../stylesheets/App.css";
import "../../stylesheets/Header.css";
import React, { useState, useEffect, useRef } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link, useNavigate } from "react-router-dom";

function HeaderHome(props) {
  const navRef = useRef(null);
  const submenuRef = useRef(null);

  const [menu, setMenu] = useState(false);
  const [submenu, setSubmenu] = useState(false);
  const [isAdmin, setIsAdmin] = useState(0);

  const navigate = useNavigate();
  const [key, setKey] = useState(props.keywords ? props.keywords : "");

  const apiCall = (url, consecuencia) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => consecuencia(data))
      .catch((error) => console.log(error));
  };

  const updateIsAdmin = (data) => {
    setIsAdmin(data.data);
  };

  useEffect(() => {
    const userInfo = localStorage.getItem("user-info");
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      apiCall(
        process.env.REACT_APP_API_BASE_URL + "/admin/is-admin/" + parsed.idUser,
        updateIsAdmin
      );
    }
  }, []);

  useEffect(() => {
    const html = document.getElementById("html-ref");
    const nav = navRef.current;

    if (!nav || !html) return;

    if (menu) {
      nav.classList.add("active");
      html.classList.add("block-scroll");
    } else {
      nav.classList.remove("active");
      html.classList.remove("block-scroll");
    }
  }, [menu]);

  useEffect(() => {
    const sub = submenuRef.current;
    if (!sub) return;

    if (submenu) sub.classList.add("active");
    else sub.classList.remove("active");
  }, [submenu]);

  const updateMenu = () => setMenu((prev) => !prev);

  const closeMenu = () => {
    const nav = navRef.current;
    if (nav) nav.classList.remove("active");
    setMenu(false);
  };

  const logout = () => {
    localStorage.removeItem("user-info");

    const html = document.getElementById("html-ref");
    if (html) html.classList.remove("block-scroll");

    navigate("/login");
  };

  const updateSubmenu = () => {
    setSubmenu((prev) => !prev);

    const el = document.getElementById("ranking-li");
    if (el) el.classList.toggle("active");
  };

  const updateKeywords = (e) => {
    const codigo = e.which || e.keyCode;
    if (codigo === 13 && props.setKeywords) {
      props.setKeywords(key);
    }
  };

  return (
    <>
      <header>
        <div className="header-container-flex">
          <div>
            <h2>Hola, </h2>
            <h1>
              {localStorage.getItem("user-info")
                ? JSON.parse(localStorage.getItem("user-info")).name
                : ""}
            </h1>
          </div>
          <div>
            <button className="header-btn" onClick={updateMenu}>
              <FontAwesomeIcon icon={solid("bars")} />
            </button>
          </div>
        </div>

        <div className="search-container-home" id="search-container-home">
          <button className="search-btn">
            <FontAwesomeIcon icon={solid("magnifying-glass")} />
          </button>
          <input
            type="text"
            placeholder="Buscar por equipos, paises"
            value={key}
            onInput={(e) => setKey(e.target.value)}
            onKeyUp={updateKeywords}
          />
        </div>
      </header>

      <nav className="nav-bar" ref={navRef}>
        <div className="nav-out" onClick={closeMenu}></div>
        <div className="nav-container">
          <ul>
            <div className="div-img">
              <img
                src={process.env.PUBLIC_URL + "/images/Logo-Menu-HMQ.png"}
                alt=""
              />
            </div>

            {isAdmin == 1 ? (
              <>
                <Link to="/admin" onClick={closeMenu}>
                  <li>Gestión de Quiniela</li>
                </Link>
                <Link to="/qr-admin" onClick={closeMenu}>
                  <li>Gestión de QRs</li>
                </Link>
                <li className="item-with-childrens" id="ranking-li">
                  <div onClick={updateSubmenu}>
                    Ranking <FontAwesomeIcon icon={solid("chevron-down")} />
                  </div>
                  <ul className="submenu-list-ranking" ref={submenuRef}>
                    <Link to="/stage-ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Fase</li>
                    </Link>
                    <Link to="/ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Global</li>
                    </Link>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <Link to="/" onClick={closeMenu}>
                  <li>Pronósticos</li>
                </Link>
                <Link to="/my-score" onClick={closeMenu}>
                  <li>Mis puntos</li>
                </Link>
                <li className="item-with-childrens" id="ranking-li">
                  <div onClick={updateSubmenu}>
                    Ranking <FontAwesomeIcon icon={solid("chevron-down")} />
                  </div>
                  <ul className="submenu-list-ranking" ref={submenuRef}>
                    <Link to="/stage-ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Fase</li>
                    </Link>
                    <Link to="/ranking" onClick={closeMenu}>
                      <li className="submenu-item-ranking">Global</li>
                    </Link>
                  </ul>
                </li>
                <Link to="/rules" onClick={closeMenu}>
                  <li>Reglas</li>
                </Link>
                <Link to="/awards" onClick={closeMenu}>
                  <li>Premios</li>
                </Link>
                <Link to="/profile" onClick={closeMenu}>
                  <li>Mi perfil</li>
                </Link>
              </>
            )}

            <hr className="line-menu" />
            <div className="logout-container">
              <img
                src={process.env.PUBLIC_URL + "/images/assets/logout.png"}
                alt=""
              />
              <p className="logout-p" onClick={logout}>
                Cerrar sesión
              </p>
            </div>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default HeaderHome;
